import React from 'react'
import {InputLabel} from '@material-ui/core'

export default function Label({label,...others}){
    return (
        <label style={{textAlign:"initial"}} {...others}>{label}</label>
    )
}